"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _DrupalFlipNugget = _interopRequireDefault(require("./Nuggets/DrupalFlipNugget"));

var _DrupalChatNugget = _interopRequireDefault(require("./Nuggets/DrupalChatNugget"));

var _DrupalHtmlNugget = _interopRequireDefault(require("./Nuggets/DrupalHtmlNugget"));

var _DrupalQuizNugget = _interopRequireDefault(require("./Nuggets/DrupalQuizNugget"));

var _DrupalUrlNugget = _interopRequireDefault(require("./Nuggets/DrupalUrlNugget"));

var _DrupalQRReaderNugget = _interopRequireDefault(require("./Nuggets/DrupalQRReaderNugget"));

var _DrupalEkgNugget = _interopRequireDefault(require("./Nuggets/DrupalEkgNugget"));

var _DrupalVideoNugget = _interopRequireDefault(require("./Nuggets/DrupalVideoNugget"));

var _DrupalVoteNugget = _interopRequireDefault(require("./Nuggets/DrupalVoteNugget"));

var _DrupalSwipeNugget = _interopRequireDefault(require("./Nuggets/DrupalSwipeNugget"));

var _DrupalQdNugget = _interopRequireDefault(require("./Nuggets/QDNuggets/DrupalQdNugget"));

var _DrupalFormNugget = _interopRequireDefault(require("./Nuggets/DrupalFormNugget"));

var _FlipNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/FlipNugget"));

var _ChatNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/ChatNugget"));

var _ContainerNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/ContainerNugget"));

var _HtmlNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/HtmlNugget"));

var _QuizNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/QuizNugget"));

var _UrlNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/UrlNugget"));

var _VideoNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/VideoNugget"));

var _VoteNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/VoteNugget"));

var _SwipeNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/SwipeNugget"));

var _QRReaderNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/QRReaderNugget"));

var _QdNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/QdNugget"));

var _QDQuestionEditorNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/QDQuestionEditorNugget"));

var _FormNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/FormNugget"));

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

var _DrupalQDQuestionEditorNugget = _interopRequireDefault(require("./Nuggets/QDNuggets/DrupalQDQuestionEditorNugget"));

var _PDFNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/PDFNugget"));

var _DrupalPDFNugget = _interopRequireDefault(require("./Nuggets/DrupalPDFNugget"));

var _ListNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/ListNugget"));

var _DrupalListNugget = _interopRequireDefault(require("./Nuggets/DrupalListNugget"));

var _TerminNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/TerminNugget"));

var _DrupalTerminNugget = _interopRequireDefault(require("./Nuggets/DrupalTerminNugget"));

var _GalleryNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/GalleryNugget"));

var _DrupalGalleryNugget = _interopRequireDefault(require("./Nuggets/DrupalGalleryNugget"));

var _DrupalContainerNugget = _interopRequireDefault(require("./Nuggets/DrupalContainerNugget"));

var _EventSeriesNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/EventSeriesNugget"));

var _RubricNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/RubricNugget"));

var _DrupalNuggetStrings = require("./Nuggets/DrupalNuggetStrings");

var _Nugget = _interopRequireDefault(require("./Nuggets/Nugget.scss"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _KESI2Helper = _interopRequireWildcard(require("../../../KESI2/KESI2Helper"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _KesiConstants = require("../../../KESI2/KesiConstants");

var _RemoteControlService = require("../../../KESI2/Services/RemoteControlService");

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _FeedbackService = require("../../../KESI2/Services/FeedbackService");

var _MazarsCertNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/MazarsCertNugget"));

var _DrupalMazarsCertNugget = _interopRequireDefault(require("./Nuggets/DrupalMazarsCertNugget"));

var _MuiAlertHelper = require("../../../helpers/MuiAlertHelper");

var _reactMdl = require("react-mdl");

var _DrupalEventSeriesNugget = _interopRequireDefault(require("./Nuggets/DrupalEventSeriesNugget"));

var _DrupalRubricNugget = _interopRequireDefault(require("./Nuggets/DrupalRubricNugget"));

var _Constants = require("../../constants/Constants");

var _FeedbackNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/FeedbackNugget"));

var _FeedbackContainerNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/FeedbackContainerNugget"));

var _DrupalFeedbackNugget = _interopRequireDefault(require("./Nuggets/DrupalFeedbackNugget"));

var _DrupalFeedbackContainerNugget = _interopRequireDefault(require("./Nuggets/DrupalFeedbackContainerNugget"));

var _LiveTickerNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/LiveTickerNugget"));

var _DrupalLiveTickerNugget = _interopRequireDefault(require("./Nuggets/DrupalLiveTickerNugget"));

var _EkgNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/EkgNugget"));

var _LikertNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/LikertNugget"));

var _DrupalLikertNugget = _interopRequireDefault(require("./Nuggets/DrupalLikertNugget"));

var _PodcastNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/PodcastNugget"));

var _DrupalPodcastNugget = _interopRequireDefault(require("./Nuggets/DrupalPodcastNugget"));

var _LikertResultNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/LikertResultNugget"));

var _DrupalLikertResultNugget = _interopRequireDefault(require("./Nuggets/DrupalLikertResultNugget"));

var _WizardNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/WizardNugget"));

var _DrupalWizardNugget = _interopRequireDefault(require("./Nuggets/DrupalWizardNugget"));

var _SelfReflectNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/SelfReflectNugget"));

var _DrupalSelfReflectNugget = _interopRequireDefault(require("./Nuggets/DrupalSelfReflectNugget"));

var _EPRFormNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/EPRFormNugget"));

var _DrupalEPRFormNugget = _interopRequireDefault(require("./Nuggets/DrupalEPRFormNugget"));

var _ReminderNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/ReminderNugget"));

var _DrupalReminderNugget = _interopRequireDefault(require("./Nuggets/DrupalReminderNugget"));

var _DataStoreNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/DataStoreNugget"));

var _DrupalDataStoreNugget = _interopRequireDefault(require("./Nuggets/DrupalDataStoreNugget"));

var _VideoPlaylistNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/VideoPlaylistNugget"));

var _DrupalVideoPlaylistNugget = _interopRequireDefault(require("./Nuggets/DrupalVideoPlaylistNugget"));

var _EventDateNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/EventDateNugget"));

var _LivestreamNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/LivestreamNugget"));

var _DrupalLivestreamNugget = _interopRequireDefault(require("./Nuggets/DrupalLivestreamNugget"));

var _CodeNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/CodeNugget"));

var _ErgoChatNugget = _interopRequireDefault(require("../../../KESI2/entities/nuggets/ErgoChatNugget"));

var _DrupalErgoChatNugget = _interopRequireDefault(require("./Nuggets/DrupalErgoChatNugget"));

var _ArrayHelper = require("../../../helpers/ArrayHelper");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DrupalNuggetGeneric = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalNuggetGeneric, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalNuggetGeneric);

  function DrupalNuggetGeneric(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalNuggetGeneric);
    _this = _super.call(this, props, context, props.id);
    /*
    KESI2BasicComponent also defines state, in order to keep DrupalLecture state
    and the already initialized Kesi2BasicComponent state we use ...this.state here.
    */

    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderNuggetIcon", function (nugget) {
      var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!_config["default"].showNuggetIcons) {
        return null;
      }

      var active = _DataStore["default"].pathExists("".concat(_this.props.id, ".").concat(_this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), _this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? _this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][_this.props.id][_this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var icon = '';
      var nuggetString = '';
      var additionalIconToRender = null;

      if (nugget instanceof _ChatNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/chat.svg') : require('./Nuggets/assets/chat_off.svg') : require('./Nuggets/assets/chat.svg');
        nuggetString = _ChatNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _VideoNugget["default"] || nugget instanceof _VideoPlaylistNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/video.svg') : require('./Nuggets/assets/video_off.svg') : require('./Nuggets/assets/video.svg');
        nuggetString = _VideoNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _UrlNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/url.svg') : require('./Nuggets/assets/url_off.svg') : require('./Nuggets/assets/url.svg');
        nuggetString = _UrlNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _QDQuestionEditorNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/quiz.svg') : require('./Nuggets/assets/quiz_off.svg') : require('./Nuggets/assets/quiz.svg');
        nuggetString = _QDQuestionEditorNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _VoteNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/vote.svg') : require('./Nuggets/assets/vote_off.svg') : require('./Nuggets/assets/vote.svg');
        nuggetString = _VoteNugget["default"].CLASS.toUpperCase();
        additionalIconToRender = (0, _KESI2Helper.isKesiMaster)() ? /*#__PURE__*/_react["default"].createElement("img", {
          className: innerClassNames,
          onClick: function onClick() {
            // this.setState({waitingForDelete: true})
            (0, _FeedbackService.resetAnswers)(_this.props.id);
          },
          src: require('./Nuggets/assets/resetAnswers.svg')
        }) : null;
      }

      if (nugget instanceof _LikertNugget["default"] || nugget instanceof _LikertResultNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/vote.svg') : require('./Nuggets/assets/vote_off.svg') : require('./Nuggets/assets/vote.svg');
        nuggetString = _LikertNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _SelfReflectNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/vote.svg') : require('./Nuggets/assets/vote_off.svg') : require('./Nuggets/assets/vote.svg');
        nuggetString = _SelfReflectNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _FlipNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/flip.svg') : require('./Nuggets/assets/flip_off.svg') : require('./Nuggets/assets/flip.svg');
        nuggetString = _FlipNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _QuizNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/quiz.svg') : require('./Nuggets/assets/quiz_off.svg') : require('./Nuggets/assets/quiz.svg');
        nuggetString = _QuizNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _SwipeNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/swipe.svg') : require('./Nuggets/assets/swipe_off.svg') : require('./Nuggets/assets/swipe.svg');
        nuggetString = _SwipeNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _WizardNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/swipe.svg') : require('./Nuggets/assets/swipe_off.svg') : require('./Nuggets/assets/swipe.svg');
        nuggetString = _WizardNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _GalleryNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/gallery.svg') : require('./Nuggets/assets/gallery_off.svg') : require('./Nuggets/assets/gallery.svg');
        nuggetString = _GalleryNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _ContainerNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/gallery.svg') : require('./Nuggets/assets/gallery_off.svg') : require('./Nuggets/assets/gallery.svg');
        nuggetString = _ContainerNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _QdNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/quiz.svg') : require('./Nuggets/assets/quiz_off.svg') : require('./Nuggets/assets/quiz.svg');
        nuggetString = _QdNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _FormNugget["default"] || nugget instanceof _EPRFormNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/html.svg') : require('./Nuggets/assets/html_off.svg') : require('./Nuggets/assets/html.svg');
        nuggetString = _FormNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _PDFNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/pdf.svg') : require('./Nuggets/assets/pdf_off.svg') : require('./Nuggets/assets/pdf.svg');
        nuggetString = _PDFNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _ListNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/list.svg') : require('./Nuggets/assets/list_off.svg') : require('./Nuggets/assets/list.svg');
        nuggetString = _ListNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _TerminNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/event.svg') : require('./Nuggets/assets/event_off.svg') : require('./Nuggets/assets/event.svg');
        nuggetString = _TerminNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _EventSeriesNugget["default"] || nugget instanceof _EventDateNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/event.svg') : require('./Nuggets/assets/event_off.svg') : require('./Nuggets/assets/event.svg');
        nuggetString = _EventSeriesNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _RubricNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/event.svg') : require('./Nuggets/assets/event_off.svg') : require('./Nuggets/assets/event.svg');
        nuggetString = _RubricNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _MazarsCertNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/event.svg') : require('./Nuggets/assets/event_off.svg') : require('./Nuggets/assets/event.svg');
        nuggetString = _MazarsCertNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _HtmlNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/html.svg') : require('./Nuggets/assets/html_off.svg') : require('./Nuggets/assets/html.svg');
        nuggetString = _HtmlNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _FeedbackNugget["default"] || nugget instanceof _FeedbackContainerNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/feedback.svg') : require('./Nuggets/assets/feedback_off.svg') : require('./Nuggets/assets/feedback.svg');
        nuggetString = _FeedbackNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _LiveTickerNugget["default"] || nugget instanceof _LivestreamNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/live.svg') : require('./Nuggets/assets/live_off.svg') : require('./Nuggets/assets/live.svg');
        nuggetString = _LiveTickerNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _QRReaderNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/live.svg') : require('./Nuggets/assets/live_off.svg') : require('./Nuggets/assets/live.svg');
        nuggetString = _QRReaderNugget["default"].CLASS.toUpperCase();
      }

      if (nugget instanceof _PodcastNugget["default"]) {
        icon = (0, _KESI2Helper.isKesiMaster)() ? active ? require('./Nuggets/assets/audio.svg') : require('./Nuggets/assets/audio_off.svg') : require('./Nuggets/assets/audio.svg');
        nuggetString = _PodcastNugget["default"].CLASS.toUpperCase();
      }

      var isRead = _KESI2Helper["default"].checkIfContentIsMarkedAsReadInStore(nugget);

      var stringToRender = "".concat(nuggetString, "_INFO");

      if (_config["default"].useNuggetIconsForLearnState && nugget) {
        stringToRender = "".concat(nuggetString, "_NOT_MANDATORY");

        if ((isRead || nugget.notMandatory) && _cssConstants["default"] && _cssConstants["default"] && _cssConstants["default"].colors.nuggetReadColor) {
          icon = icon.replace(/%239b9b9b/g, "".concat(_cssConstants["default"].colors.nuggetReadColor.replace('#', '%23')));
          stringToRender = "".concat(nuggetString, "_MANDATORY_READ");
        } else if (_cssConstants["default"] && _cssConstants["default"] && _cssConstants["default"].colors.nuggetUnreadColor) {
          icon = icon.replace(/%239b9b9b/g, "".concat(_cssConstants["default"].colors.nuggetUnreadColor.replace('#', '%23')));
          stringToRender = "".concat(nuggetString, "_MANDATORY_NOT_READ");
        }
      }

      var isCommenter = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.IS_COMMENTER);

      if (isCommenter) {
        additionalIconToRender = /*#__PURE__*/_react["default"].createElement("img", {
          className: innerClassNames,
          onClick: function onClick() {
            //comment
            (0, _MuiAlertHelper.showWideAlertHtmlWithTextfields)('Bitte geben Sie Ihren Kommentar ein', 'Kommentar abgeben', null, [{
              label: (0, _DrupalNuggetStrings.getString)('COMMENT'),
              onChange: function onChange(event) {
                return _this.setComment(event, nugget.id);
              },
              multiline: true,
              value: _this.state.comments && _this.state.comments[nugget.id] ? _this.state.comments[nugget.id] : ''
            }], true, null, [{
              label: (0, _DrupalNuggetStrings.getString)('CANCEL'),
              callback: function callback() {
                _this.storeComment(nugget.id);
              }
            }, {
              label: (0, _DrupalNuggetStrings.getString)('OK'),
              callback: function callback() {
                _this.storeComment(nugget.id);
              }
            }]);
          },
          src: require('./Nuggets/assets/comment.svg')
        });
      }

      var innerIcon = _this.props.hideNuggetIcon ? null : /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(nugget.show_title && !_config["default"].showNuggetIconsAlwaysOff ? 'nuggetIconContainer' : 'nuggetIconContainerNoTitle', " ").concat(!_DeviceInfoHelper["default"].isBrowser() || window.innerWidth < _Constants.SMARTPHONE_WIDTH_PORTRAIT_BREAKPOINT ? 'mobileIcon' : ''),
        style: _this.props.inSwipeContainer || _this.props.inWizardContainer || _this.props.inListContainer || _this.props.inGalleryContainer ? {
          display: 'none'
        } : {}
      }, _this.state.waitingForActivation ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "iconSpinnerContainer"
      }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)) : /*#__PURE__*/_react["default"].createElement("img", {
        className: innerClassNames,
        src: icon // alt={getString(stringToRender)}
        ,
        ref: ref,
        onClick: (0, _KESI2Helper.isKesiMaster)() ? /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(_this.props.id, ".").concat(_this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), !active);

                case 2:
                  _context.next = 4;
                  return _KESI2Helper["default"].setVisibilities(_this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]);

                case 4:
                  (0, _RemoteControlService.pushActivateMessage)(_this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES], _this.props.id, _this.props.contentPathArray, !active);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })) : function () {}
      }), additionalIconToRender ? additionalIconToRender : null);

      if (_DeviceInfoHelper["default"].isBrowser()) {
        if (_config["default"].useNuggetIconsForLearnState) {
          return _this.props.hideNuggetIcon ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
            title: (0, _DrupalNuggetStrings.getString)(stringToRender),
            classes: {
              tooltip: "".concat(_Nugget["default"].tooltip, " tooltip")
            }
          }, innerIcon));
        } else {
          return _this.props.hideNuggetIcon ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
            title: (0, _DrupalNuggetStrings.getString)(stringToRender),
            classes: {
              tooltip: "".concat(_Nugget["default"].tooltip, " tooltip")
            }
          }, innerIcon));
        }
      }

      return /*#__PURE__*/_react["default"].createElement("div", null, innerIcon);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setComment", function (evt, id) {
      var comments = _this.state.comments || {};
      comments[id] = evt.target.value;

      _this.setState({
        comments: comments
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "storeComment", function (id) {
      var commentToStore = _this.state.comments[id];
      console.log('commentToStore', commentToStore);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setLike", function () {
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var allLikes = JSON.parse((0, _stringify["default"])(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES))) || {};
      var likeIndex = likes.indexOf(_this.props.id);
      var currentCount = allLikes[id] ? allLikes[id] : 0;

      if (allLikes[id]) {
        if (likeIndex < 0) {
          allLikes[id] = currentCount + 1;
        } else {
          allLikes[id] = currentCount - 1;
        }
      }

      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, allLikes);

      if (likeIndex < 0) {
        likes.push(_this.props.id);
        (0, _FeedbackService.pushLikeMessage)(_this.props.id, 'add', _config["default"].rootId);
      } else {
        (0, _ArrayHelper.removeElementAtPosition)(likes, likeIndex);
        (0, _FeedbackService.pushLikeMessage)(_this.props.id, 'remove', _config["default"].rootId);
      }

      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_LIKES, likes);
    });
    _this.state = _objectSpread({
      // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor
      showVideoControls: false
    }, _this.state);
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalNuggetGeneric.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, _DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalNuggetGeneric, [{
    key: "renderNugget",
    value: function renderNugget(nugget) {
      if (nugget instanceof _QRReaderNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalQRReaderNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          region: this.props.region,
          flexLink: this.props.flexLink,
          setBackButtonFunc: this.props.setBackButtonFunc,
          setTitle: this.props.setTitle,
          expanded: this.props.expanded,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _EkgNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalEkgNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          region: this.props.region,
          flexLink: this.props.flexLink,
          setBackButtonFunc: this.props.setBackButtonFunc,
          setTitle: this.props.setTitle,
          expanded: this.props.expanded,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _ChatNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalChatNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          forcedUIColor: this.props.forcedUIColor,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _ErgoChatNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalErgoChatNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          forcedUIColor: this.props.forcedUIColor,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _HtmlNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalHtmlNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          region: this.props.region,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          lectureBackgroundColor: this.props.lectureBackgroundColor,
          setLike: this.setLike,
          closePrevDialogFn: this.props.closePrevDialogFn
        });
      }

      if (nugget instanceof _VideoNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalVideoNugget["default"], {
          key: this.props.action ? "".concat(this.props.id, "_") : "".concat(this.props.id, "_").concat(this.state.showVideoControls ? 'c' : ''),
          id: this.props.id,
          action: this.props.action,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          showControls: this.state.showVideoControls,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          forcedUIColor: this.props.forcedUIColor,
          renderIcon: this.renderNuggetIcon,
          galleryContainerIndex: this.props.galleryContainerIndex,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _VideoPlaylistNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalVideoPlaylistNugget["default"], {
          id: this.props.id,
          action: this.props.action,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          showControls: this.state.showVideoControls,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          forcedUIColor: this.props.forcedUIColor,
          renderIcon: this.renderNuggetIcon,
          galleryContainerIndex: this.props.galleryContainerIndex,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _UrlNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalUrlNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          region: this.props.region,
          flexLink: this.props.flexLink,
          setBackButtonFunc: this.props.setBackButtonFunc,
          setTitle: this.props.setTitle,
          expanded: this.props.expanded,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _QDQuestionEditorNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalQDQuestionEditorNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          setTitle: this.props.setTitle,
          expanded: this.props.expanded,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _VoteNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalVoteNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inFeedbackContainer: this.props.inFeedbackContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          forcedUIColor: this.props.forcedUIColor,
          renderIcon: this.renderNuggetIcon,
          registerSendFunc: this.props.registerSendFunc,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _LikertNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalLikertNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setStepDone: this.props.setStepDone,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inFeedbackContainer: this.props.inFeedbackContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          forcedUIColor: this.props.forcedUIColor,
          renderIcon: this.renderNuggetIcon,
          registerSendFunc: this.props.registerSendFunc,
          isInTutorial: this.props.isInTutorial,
          lectureBackgroundColor: this.props.lectureBackgroundColor,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _LikertResultNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalLikertResultNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inFeedbackContainer: this.props.inFeedbackContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          forcedUIColor: this.props.forcedUIColor,
          renderIcon: this.renderNuggetIcon,
          registerSendFunc: this.props.registerSendFunc,
          isInTutorial: this.props.isInTutorial,
          lectureBackgroundColor: this.props.lectureBackgroundColor,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _FlipNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalFlipNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _QuizNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalQuizNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setStepDone: this.props.setStepDone,
          setBackButtonFunc: this.props.setBackButtonFunc,
          scrollToNugget: this.props.scrollToNugget,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          forcedUIColor: this.props.forcedUIColor,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _SwipeNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalSwipeNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          forcedUIColor: this.props.forcedUIColor,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _WizardNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalWizardNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          forcedUIColor: this.props.forcedUIColor,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          onDoneFn: this.props.onDoneFn,
          goHomeFn: this.props.goHomeFn,
          lectureBackgroundColor: this.props.lectureBackgroundColor,
          setWizardArrowFns: this.props.setWizardArrowFns,
          resetScrollIndicatorFn: this.props.resetScrollIndicatorFn,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _GalleryNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalGalleryNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _ContainerNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalContainerNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          onDoneFn: this.props.onDoneFn,
          goHomeFn: this.props.goHomeFn,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          lectureBackgroundColor: this.props.lectureBackgroundColor,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _QdNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalQdNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          setTitle: this.props.setTitle,
          setFullscreenContent: this.props.setFullscreenContent,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _FormNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalFormNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _EPRFormNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalEPRFormNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          goHomeFn: this.props.goHomeFn,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _FeedbackNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalFeedbackNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inFeedbackContainer: this.props.inFeedbackContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          registerSendFunc: this.props.registerSendFunc,
          isInTutorial: this.props.isInTutorial,
          closePrevDialogFn: this.props.closePrevDialogFn,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _FeedbackContainerNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalFeedbackContainerNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          forcedUIColor: this.props.forcedUIColor,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _PDFNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalPDFNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          forcedUIColor: this.props.forcedUIColor,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _ListNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalListNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          scrollFrameId: this.props.scrollFrameId,
          forcedUIColor: this.props.forcedUIColor,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _SelfReflectNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalSelfReflectNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          scrollFrameId: this.props.scrollFrameId,
          forcedUIColor: this.props.forcedUIColor,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setStepDone: this.props.setStepDone,
          lectureBackgroundColor: this.props.lectureBackgroundColor,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _TerminNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalTerminNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _RubricNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalRubricNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _EventSeriesNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalEventSeriesNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _MazarsCertNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalMazarsCertNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _LiveTickerNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalLiveTickerNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _LivestreamNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalLivestreamNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _PodcastNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalPodcastNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          lectureBackgroundColor: this.props.lectureBackgroundColor,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _ReminderNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalReminderNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          lectureBackgroundColor: this.props.lectureBackgroundColor,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _CodeNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(DrupalCodeNugget, {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }

      if (nugget instanceof _DataStoreNugget["default"]) {
        return /*#__PURE__*/_react["default"].createElement(_DrupalDataStoreNugget["default"], {
          id: this.props.id,
          path: this.props.path,
          registerNugget: this.props.registerNugget,
          markAsRead: this.props.markAsRead,
          contentPathArray: this.props.contentPathArray,
          inSwipeContainer: this.props.inSwipeContainer,
          inWizardContainer: this.props.inWizardContainer,
          setBackButtonFunc: this.props.setBackButtonFunc,
          closeTile: this.props.closeTile,
          inListContainer: this.props.inListContainer,
          inGalleryContainer: this.props.inGalleryContainer,
          goUpFunc: this.props.goUpFunc,
          renderIcon: this.renderNuggetIcon,
          isInTutorial: this.props.isInTutorial,
          setLike: this.setLike
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var nugget = this.state.content && this.state.content[this.props.id] ? this.state.content[this.props.id] : null;

      if (!nugget) {
        console.log("linked nugget with id ".concat(this.props.id, " not in contentstore!"));
        return null;
      }

      if ((0, _PreconditionChecker.getFailingPrecondition)(nugget.showPrecondition) !== null) {
        // console.log('not rendering nugget bc of failing precondition', nugget.id, nugget.title, getFailingPrecondition(nugget.showPrecondition))
        return null;
      }

      var renderedNugget = this.renderNugget(nugget);

      if (renderedNugget) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          tabIndex: 0
        }, renderedNugget);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: 10,
          backgroundColor: 'yellow',
          color: 'red'
        }
      }, "Unknown nugget class ", nugget["class"]);
    }
  }]);
  return DrupalNuggetGeneric;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalNuggetGeneric;
DrupalNuggetGeneric.propTypes = {
  id: _propTypes["default"].string,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func,
  markAsRead: _propTypes["default"].func,
  contentPathArray: _propTypes["default"].array,
  inSwipeContainer: _propTypes["default"].bool,
  inWizardContainer: _propTypes["default"].bool,
  setStepDone: _propTypes["default"].func,
  flexLink: _propTypes["default"].string,
  regionCode: _propTypes["default"].string,
  setBackButtonFunc: _propTypes["default"].func,
  closeTile: _propTypes["default"].func,
  setTitle: _propTypes["default"].func,
  expanded: _propTypes["default"].bool,
  scrollToNugget: _propTypes["default"].func,
  inListContainer: _propTypes["default"].bool,
  inGalleryContainer: _propTypes["default"].bool,
  galleryContainerIndex: _propTypes["default"].number,
  goUpFunc: _propTypes["default"].func,
  setFullscreenContent: _propTypes["default"].func,
  scrollFrameId: _propTypes["default"].string,
  forcedUIColor: _propTypes["default"].string,
  hideNuggetIcon: _propTypes["default"].bool,
  isInTutorial: _propTypes["default"].bool,
  onDoneFn: _propTypes["default"].func,
  goHomeFn: _propTypes["default"].func,
  lectureBackgroundColor: _propTypes["default"].string,
  setWizardArrowFns: _propTypes["default"].func,
  resetScrollIndicatorFn: _propTypes["default"].func,
  closePrevDialogFn: _propTypes["default"].func,
  backgroundColor: _propTypes["default"].string
};
DrupalNuggetGeneric.defaultProps = {
  id: null,
  inSwipeContainer: false,
  inListContainer: false,
  inGalleryContainer: false,
  goUpFunc: null,
  hideNuggetIcon: false,
  isInTutorial: false,
  registerNugget: function registerNugget() {},
  markAsRead: function markAsRead() {},
  contentPathArray: []
};